import { OnInit, Component, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PrintgroupService } from '../services/printgroup.service';
import { catchError } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { AlertService } from '../services/alert.service';
import { StorageService } from '../services/storage.service';
import jwt_decode from "jwt-decode";
import { Router } from "@angular/router";
import { of } from 'rxjs';
import { SpinnerService } from './../services/spinner.service';
import { MsalService } from '@azure/msal-angular';
import { UploadService } from '../services/upload.service';

@Component({
  selector: 'app-printgroup',
  templateUrl: './printgroup.component.html',
  styleUrls: ['./printgroup.component.css']
})
export class PrintgroupComponent implements OnInit {
  baseUrl = environment.baseUrl;
  items: any;
  @ViewChild('addPrintGroup') elPrintGroup: ElementRef;
  private route: ActivatedRoute;
  id:number;
  AddShowHide:boolean = true;
  EditShowHide:boolean = true;
  CreateShowHide:boolean = false;
  UpdateShowHide:boolean = false;
  CancelShowHide = false;
  reverse: boolean = false;
  CreatedBy: string;
  CreationDate: Date;
  public username;
  filename: any;
  isShown:boolean = true;
  imagesource: any;
  printgroupnameimg: any;

  frmPrintGroup = new FormGroup({
    PrintGroup: new FormControl('', [Validators.required, Validators.minLength(1)]),
    DesignName: new FormControl('', [Validators.required, Validators.minLength(1)]),
    PrintGroupImageName: new FormControl(''),
    PrintGroupImage  : new FormControl('', [Validators.required])

  });

  config = {
    id: 'Printgroup',
    itemsPerPage: environment.pagination.pagesize,
    currentPage: 0,
    totalItems: 0,
  };

  param = environment.pagination;
  // {
  //   SortColumnName :"Modifiedby",
  //   SortOrder :"DESC",
  //   PageSelected:0,
  //   PageSize:2
  // };

  constructor(private renderer: Renderer2, private _printgroupservice: PrintgroupService, private _alertService: AlertService,
    private router: Router,
    public storage: StorageService,
    private spinner: SpinnerService,private authService: MsalService,
    private _uploadservice: UploadService) {
      // const tokenitems = { ...localStorage };
      // if(tokenitems.TokenInfo != undefined) {
      //     var clienttoken = jwt_decode(JSON.parse(tokenitems.TokenInfo).access_token);
      //     var isAdmin;
      //     var groups;
      //     //console.log('clienttoken');
      //     //console.log(clienttoken);
      //     this.username = clienttoken["unique_name"];
      //     groups = clienttoken["groups"].split(',');

      //     isAdmin = groups.indexOf("GPI-Aces-Admins",0) != -1;
      //     if(!isAdmin){
      //         this.router.navigate(['/accessdenied']);
      //     }
      // }

  }

  ngOnInit() {
    this.spinner.showSpinner();
    const activeAccount = this.authService.instance.getActiveAccount();
    if (activeAccount) {
      this.username = activeAccount.username;
    }
    //console.log(this.param);
    this.GetPrintGroups();
    this.spinner.hideSpinner();
  }

  SortOder(sortBy){
    if (this.param.SortOrder === "ASC") {
      this.reverse = !this.reverse;
      this.param.SortOrder = "DESC"
    } else{
      this.param.SortOrder = "ASC"
    }
    this.param.SortColumnName = sortBy;
    this.GetPrintGroups();
  }

  Cancel(){
    this.spinner.showSpinner();
    this.id = 0;
    this.frmPrintGroup.setValue({PrintGroup:"",DesignName:"", PrintGroupImageName:"", PrintGroupImage: ""});
    this.AddShowHide = true;
    this.EditShowHide = true;
    this.CreateShowHide = false;
    this.UpdateShowHide =false;
    this.CancelShowHide = false;
    this.spinner.hideSpinner();
  }

  GetPrintGroups() {
    this._printgroupservice.getPrintgroupList(this.param).subscribe((data: any) => {
      //console.log('data');
      //console.log(data);
      var stringified = JSON.stringify(data);
      this.items = JSON.parse(stringified).PagedDataModel;
      this.config.totalItems = JSON.parse(stringified).page.TotalCount;

   });
  }

  pageChanged(event){
    this.config.currentPage = event;
    this.param.PageSelected = event;
    this.GetPrintGroups();
  }

  EditPrintGroup(item){
    this.spinner.showSpinner();
    //console.log(item);
    this.id = item.Id;
    this.CreatedBy = item.CreatedBy;
    this.CreationDate = item.CreationDate;
    this.printgroupnameimg= item.PrintGroupImageName;
    this.frmPrintGroup.setValue({
      PrintGroup:item.PrintGroup1,
      DesignName:item.DesignName,
      PrintGroupImageName:item.PrintGroupImageName,
      PrintGroupImage: item.PrintGroupImageName

        });

    this.EditShowHide = false;
    this.AddShowHide = false;
    this.CreateShowHide = false;
    this.UpdateShowHide =true;
    this.CancelShowHide = true;

    //console.log(this.EditShowHide);
    //console.log(this.AddShowHide);
    //console.log(this.UpdateShowHide);

    this.spinner.hideSpinner();
  }



AddPrintGroup(){
  this.spinner.showSpinner();
  this.id = 0;
  this.AddShowHide = false;
  this.EditShowHide = false;
  this.CreateShowHide = true;
  this.UpdateShowHide =false;
  this.CancelShowHide = true;
  this.spinner.hideSpinner();
}

Validation(frmP:FormGroup){
  let invalidfield : String = '';

if (frmP.invalid) {
    Object.keys(frmP.controls).forEach((key) => {
        if(frmP.get(key).invalid == true){

          if (key === "PrintGroup") {
            if (invalidfield == '') {
                invalidfield = "Please enter Print Group" + "<br/>";
            } else {
                invalidfield += "Please enter Print Group" + "<br/>";
            }
        }

        if (key === "DesignName") {
          if (invalidfield == '') {
              invalidfield = "Please enter Design Name" + "<br/>";
          } else {
              invalidfield += "Please enter Design Name" + "<br/>";
          }
        }
            // if(invalidfield == ''){
            //     invalidfield = "Please enter " +  key.charAt(0).toUpperCase() + key.substr(1).toLowerCase()+ "<br/>";
            // } else {
            //     invalidfield += "Please enter " + key.charAt(0).toUpperCase() + key.substr(1).toLowerCase() + "<br/> ";
            // }
        }
    });
    this._alertService.showError(invalidfield);
  }
}

  CreatePrintGroup(files) {
  this.spinner.showSpinner();
  if (this.frmPrintGroup.invalid) {
    this.Validation(this.frmPrintGroup);
    this.spinner.hideSpinner();
    return;
  }

  if(files[0] != null){
    this.save(files);
  }

  let PrintGroupModel = {
      PrintGroup1: this.frmPrintGroup.get('PrintGroup').value,
      DesignName: this.frmPrintGroup.get('DesignName').value,
      PrintGroupImageName: this.frmPrintGroup.get('PrintGroupImageName').value,

    CreatedBy: this.username,
    CreationDate: new Date(),
    LastModifiedBy: this.username,
    LastModificationDate: new Date()
  }

  let retvalue = this._printgroupservice.postPrintgroup(PrintGroupModel);
  retvalue.pipe(
    catchError(err => {
      this._alertService.showError("Error while creating record");
      return of(null);
    })).subscribe((value: any) => {
      this.param.SortOrder = "DESC";
    this.GetPrintGroups();
    this.Cancel();
    this._alertService.showSuccess("Record created successfully");
    })

    this.spinner.hideSpinner();
  }

  UpdatePrintGroup(files) {
    this.spinner.showSpinner();
    if (this.frmPrintGroup.invalid) {
      this.Validation(this.frmPrintGroup);
      this.spinner.hideSpinner();
      return;
    }

    if(files[0] != null){
      this.save(files);
    }

    let PrintGroupModel = {
      id: this.id,
      PrintGroup1: this.frmPrintGroup.get('PrintGroup').value,
      DesignName: this.frmPrintGroup.get('DesignName').value,
      PrintGroupImageName: this.frmPrintGroup.get('PrintGroupImageName').value,

      LastModifiedBy: this.username,
      LastModificationDate: new Date(),
      CreationDate: this.CreationDate,
      CreatedBy: this.CreatedBy
    }

    let retvalue = this._printgroupservice.putPrintgroup(PrintGroupModel);

    retvalue.pipe(
      catchError(err => {
        alert("Error while creating record!!!");
        return of(null);
      })).subscribe((value: any) => {
        this.param.SortOrder = "DESC";
        this.GetPrintGroups();
        this.Cancel();
        setTimeout("",1000);
        this._alertService.showSuccess("Record updated successfully");
        //console.log('successfully updated')
      })

      this.spinner.hideSpinner();
  }

  //delete print group
  DeletePrintGroup(printGroupId: number) {
    if (confirm('Are you sure to delete this record ?')) {
      this._printgroupservice.deletePrintgroup(printGroupId).subscribe(
        (data: any) => {
          this._alertService.showSuccess("Deleted successfully");
        },
        err => {
          if (err.status == 400)
            this._alertService.showError("No data exists");
          else
            this._alertService.showError("Bad request");
        }
      );
      this.GetPrintGroups();
    }
  }

  setFilename(files) {
    if (files[0]) {
      this.filename = files[0].name;
      this.isShown = false;
    }
  }
  
  save(files) {
    var start = Date.now().toString();
    var timestampSuffix = start.substr(start.length - 4);
    
    if(this.filename===undefined)
      return;
    const formdata = new FormData();
    var filename ='';
    
    
    filename = this.frmPrintGroup.value.PrintGroup + timestampSuffix+  '.jpg';
    if (files[0]) {
      //console.log(files[0].name);
    
      formdata.append(filename, files[0]);
      //console.log("append" )
    }
    //console.log(filename);
    this.frmPrintGroup.patchValue({PrintGroupImageName: filename});
    //console.log(formdata);
    //console.log(this.frmProduct.value.ProductName);
  
    this._uploadservice
      .upload(formdata)
      .subscribe(({ path }) => (this.imagesource = path));
    formdata.delete(filename);
    } 

}
